<section class="page" [class.mobile-page]="isMobileBrowser()" data-testid="appointments-provider-page">
  <app-page-header
    title="Select a Provider"
    subtitle="Choose who you want to request an appointment with."
    [hideBack]="true"
    (back)="onCancel()"></app-page-header>

  <div class="page-content">
    <ng-container *ngrxLet="{ careTeam: careTeam$, isLoading: isLoading$ } as vm">
      @if (vm.isLoading) {
        <app-progress-spinner data-testid="appointments-provider-spinner"></app-progress-spinner>
      } @else {
        <div class="list" data-testid="appointments-provider-list">
          <div class="search">
            <app-icon name="search" size="sm" color="on-surface"></app-icon>
            <input
              #searchInput
              type="text"
              class="search-input"
              placeholder="Search providers"
              [value]="searchText()"
              (input)="searchText.set($any($event.target).value || '')"
              aria-label="Search providers" />
            <button
              type="button"
              class="clear-btn"
              [class.is-hidden]="searchText().trim().length === 0"
              [disabled]="searchText().trim().length === 0"
              aria-label="Clear search"
              (click)="onClearSearch(searchInput)">
              <app-icon name="close" size="sm" color="on-surface"></app-icon>
            </button>
          </div>

          @if (!vm.careTeam || vm.careTeam.length === 0) {
            <div id="noCareTeamMembers" class="empty" data-testid="appointments-provider-empty">
              <app-empty-state
                iconName="group"
                [title]="getEmptyStateCopy()"
                [subtitle]="getEmptyStateSubtitle()"
                [hint]="getEmptyStateHint()"></app-empty-state>
            </div>
          } @else if (filterCareTeam(vm.careTeam).length === 0) {
            <div class="empty" data-testid="appointments-provider-empty">
              <app-empty-state
                iconName="search_off"
                [title]="getEmptyStateCopy()"
                [subtitle]="getEmptyStateSubtitle()"
                [hint]="getEmptyStateHint()"></app-empty-state>
            </div>
          } @else {
            <div class="provider-grid" role="radiogroup" aria-label="Providers">
              @for (
                careTeamMember of filterCareTeam(vm.careTeam);
                track careTeamMember.providerUserId;
                let idx = $index
              ) {
                <div
                  class="provider-card"
                  [class.is-selected]="selectedProviderUserId() === careTeamMember.providerUserId"
                  [attr.data-testid]="'schedule-option-' + idx"
                  role="radio"
                  [attr.aria-checked]="selectedProviderUserId() === careTeamMember.providerUserId"
                  tabindex="0"
                  (click)="onProviderActivate(careTeamMember.providerUserId)"
                  (keydown)="onRowKeydown($event, careTeamMember.providerUserId)">
                  <span class="left" aria-hidden="true">
                    <app-icon name="account_circle" size="xl" color="on-surface"></app-icon>
                  </span>

                  <span class="meta">
                    <span class="name">{{ careTeamMember.displayName }}</span>
                    <span class="sub">{{ getPrimaryTeamName(careTeamMember) }}</span>
                  </span>

                  <span class="right" aria-hidden="true">
                    @if (isMobileBrowser()) {
                      @if (selectedProviderUserId() === careTeamMember.providerUserId) {
                        <span class="check">
                          <app-icon name="check" size="sm" color="on-primary"></app-icon>
                        </span>
                      } @else {
                        <span class="radio"></span>
                      }
                    } @else {
                      <app-icon name="chevron_right" size="sm" color="on-surface-variant"></app-icon>
                    }
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </ng-container>
  </div>

  @if (!isModal) {
    <footer class="page-footer">
      <button
        mat-stroked-button
        type="button"
        class="error-btn"
        data-testid="appointments-step-cancel"
        (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        mat-flat-button
        class="primary-btn"
        data-testid="appointments-step-continue"
        [disabled]="!selectedProviderUserId()"
        (click)="onContinue()">
        Continue
      </button>
    </footer>
  }
</section>
